/**
 * Пикер клиентов организации (BusinessClient), без глобального getUsers.
 */

export function organizationIdFrom(org) {
  if (!org) return null;
  const raw = org.id != null ? org.id : org.Id;
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  return Number.isNaN(n) || n <= 0 ? null : n;
}

export function orgClientOptionKey(item) {
  const userId = item && (item.userId != null ? item.userId : item.UserId);
  const bc =
    item
    && (item.businessClientId != null
      ? item.businessClientId
      : item.BusinessClientId != null
        ? item.BusinessClientId
        : item.id != null ? item.id : item.Id);
  if (userId != null && userId !== '') return `u-${userId}`;
  if (bc != null && bc !== '') return `bc-${bc}`;
  return '';
}

export function mapOrgClientsToPickerOptions(items, { paidUserIds = null } = {}) {
  const paid = paidUserIds || new Set();
  return (items || [])
    .map((c) => {
      if (!c) return null;
      const userIdRaw =
        c.userId != null ? c.userId
          : c.UserId != null ? c.UserId
            : c.linkedUserId != null ? c.linkedUserId
              : c.LinkedUserId;
      const userId = userIdRaw != null && userIdRaw !== '' ? Number(userIdRaw) : null;
      const bcRaw =
        c.businessClientId != null ? c.businessClientId
          : c.BusinessClientId != null ? c.BusinessClientId
            : c.id != null ? c.id
              : c.Id;
      const businessClientId = bcRaw != null && bcRaw !== '' ? Number(bcRaw) : null;
      const name = c.name || c.Name || c.displayName || c.DisplayName || '';
      const phone =
        c.phoneNumber || c.PhoneNumber || c.phoneRaw || c.PhoneRaw || c.phoneNormalized || c.PhoneNormalized || '';
      const isLinked = c.isLinked === true || c.IsLinked === true || (userId != null && !Number.isNaN(userId));
      const uid = userId != null && !Number.isNaN(userId) ? userId : null;
      const parts = [name, phone].filter(Boolean);
      const key = uid != null ? `u-${uid}` : (businessClientId != null ? `bc-${businessClientId}` : '');
      if (!key) return null;
      return {
        key,
        userId: uid,
        businessClientId: businessClientId != null && !Number.isNaN(businessClientId) ? businessClientId : null,
        name,
        phone,
        isLinked: !!isLinked && uid != null,
        hasPaidAbonementForSection: uid != null && paid.has(Number(uid)),
        label: parts.join(' · ') || 'Клиент',
      };
    })
    .filter(Boolean)
    .sort((a, b) => {
      if (a.hasPaidAbonementForSection !== b.hasPaidAbonementForSection) {
        return a.hasPaidAbonementForSection ? -1 : 1;
      }
      if (a.isLinked !== b.isLinked) return a.isLinked ? -1 : 1;
      return (a.label || '').localeCompare(b.label || '', 'ru');
    });
}

export function mergePickerOptions(orgOptions = [], sectionOptions = []) {
  const byUser = new Map();
  const unlinked = [];
  const pushOrg = (o) => {
    if (!o) return;
    if (o.userId != null && !Number.isNaN(Number(o.userId))) {
      byUser.set(Number(o.userId), { ...o, isLinked: true });
      return;
    }
    unlinked.push(o);
  };
  (orgOptions || []).forEach(pushOrg);
  (sectionOptions || []).forEach((o) => {
    if (!o || o.userId == null || Number.isNaN(Number(o.userId))) return;
    const id = Number(o.userId);
    const prev = byUser.get(id);
    if (prev) {
      byUser.set(id, {
        ...prev,
        hasPaidAbonementForSection: !!(prev.hasPaidAbonementForSection || o.hasPaidAbonementForSection),
        label: prev.label || o.label,
      });
      return;
    }
    byUser.set(id, {
      key: `u-${id}`,
      userId: id,
      businessClientId: o.businessClientId || null,
      name: o.name || o.label || '',
      phone: o.phone || '',
      isLinked: true,
      hasPaidAbonementForSection: !!o.hasPaidAbonementForSection,
      label: o.label || `Клиент ${id}`,
    });
  });
  return [...unlinked, ...byUser.values()].sort((a, b) => {
    if (a.hasPaidAbonementForSection !== b.hasPaidAbonementForSection) {
      return a.hasPaidAbonementForSection ? -1 : 1;
    }
    if (a.isLinked !== b.isLinked) return a.isLinked ? -1 : 1;
    return (a.label || '').localeCompare(b.label || '', 'ru');
  });
}

export function filterOrgClientOptions(options, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return options || [];
  const qDigits = q.replace(/\D/g, '');
  return (options || []).filter((o) => {
    const hay = `${o.label || ''} ${o.name || ''} ${o.phone || ''}`.toLowerCase();
    if (hay.includes(q)) return true;
    if (qDigits.length >= 3) {
      const phoneDigits = String(o.phone || o.label || '').replace(/\D/g, '');
      if (phoneDigits.includes(qDigits)) return true;
    }
    return false;
  });
}

export function findOrgClientOption(options, value) {
  if (value === '' || value == null) return null;
  const v = String(value);
  return (options || []).find((o) => {
    if (!o) return false;
    if (o.key && String(o.key) === v) return true;
    if (o.userId != null && String(o.userId) === v) return true;
    if (o.businessClientId != null && (`bc-${o.businessClientId}` === v || String(o.businessClientId) === v)) {
      return true;
    }
    return false;
  }) || null;
}

export function linkedUserIdFromPickerValue(options, value) {
  const opt = findOrgClientOption(options, value);
  if (opt && opt.userId != null) return Number(opt.userId);
  const n = Number(value);
  return Number.isNaN(n) || n <= 0 ? null : n;
}

export function clientRefFromPickerValue(options, value) {
  const opt = findOrgClientOption(options, value);
  if (!opt) {
    const raw = String(value || '');
    if (raw.indexOf('bc-') === 0) {
      const n = Number(raw.slice(3));
      return { userId: null, businessClientId: Number.isNaN(n) || n <= 0 ? null : n };
    }
    const n = Number(value);
    if (!Number.isNaN(n) && n > 0) return { userId: n, businessClientId: null };
    return { userId: null, businessClientId: null };
  }
  const uid = opt.userId != null && opt.userId !== '' ? Number(opt.userId) : null;
  const bc = opt.businessClientId != null && opt.businessClientId !== '' ? Number(opt.businessClientId) : null;
  return {
    userId: uid != null && !Number.isNaN(uid) && uid > 0 ? uid : null,
    businessClientId: bc != null && !Number.isNaN(bc) && bc > 0 ? bc : null,
  };
}

export function hasPickerClient(ref) {
  return !!(ref && (ref.userId || ref.businessClientId));
}

export function sectionClientWriteFields(ref) {
  const body = {};
  if (ref && ref.userId) body.userId = ref.userId;
  if (ref && ref.businessClientId) body.businessClientId = ref.businessClientId;
  return body;
}
